import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import AddIcon from '@mui/icons-material/Add';

function BranchIndex() {
  const { isAuthenticated, companyId, branchId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  let companyid = companyId;

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }

  }, [isAuthenticated, companyId, branchId, token, logout]);

  const hasCreateMasterPermission = permissions.includes('Create Master');
  const hasEditMasterPermission = permissions.includes('Edit Master');
  const hasDeleteMasterPermission = permissions.includes('Delete Master');

  useEffect(() => {
    if (isSuperAdmin) {
      fetchData('BranchApi', `/${companyid}`, token)
        .then((response) => {
          if (response.responseCode === '1111') {
            console.log(response);
            setData(response.response_data);
          }
        })
        .catch((error) => {
          console.error('Error fetching Branch Details:', error);
        });
    } else {
      fetchData('BranchApi', `/BranchData/${branchId}`, token)
        .then((response) => {
          if (response.responseCode === '1111') {
            console.log(response);
            setData(response.response_data);
          }
        })
        .catch((error) => {
          console.error('Error fetching Branch Details:', error);
        });
    }
  }, [isSuperAdmin, companyid, branchId, token]); // Adding dependencies for more specific control



  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">
      <div className='w-full mb-2 flex'>
        <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Branch</h6>
        {isSuperAdmin && companyId == superCompanyId && (
          <Button

            component={Link}
            to="/branchCreate"
            className="linkcolor"
            style={{ marginLeft: '8px', color: 'orangered', fontWeight: 'bolder' }}
          >
            <AddIcon style={{ color: 'orangered', fontWeight: 'bolder' }} /> CREATE NEW
          </Button>
        )}
      </div>

      <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#58A5B3' }}>
              <TableRow>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Sl.No</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Name</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Branch Code</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Contact Number </TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Email</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>GST Number</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>CIN Number</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: '#C3E9E4' }}>
              {data.map((item,index) => (
                <TableRow key={item.Id}>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', fontSize: '14px' }}>{index+1}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', fontSize: '14px' }}>{item.Name}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', fontSize: '14px' }}>{item.BranchCode}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', fontSize: '14px' }}>{item.ContactNumber1}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', fontSize: '14px' }}>{item.Email}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', fontSize: '14px' }}>{item.GSTNumber}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', fontSize: '14px' }}>{item.CINNumber}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', textAlign: 'right', fontSize: '14px' }}>
                    {hasEditMasterPermission && (
                      <Link to={`/branchEdit/${item.Id}`}>
                        <IconButton color="primary">
                          <EditIcon style={{ height: '22px' }} />
                        </IconButton>
                      </Link>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div className="watermark">
        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>

  );
}

export default BranchIndex;

